import React from 'react';
import { AccentH5 } from 'scy/text';
import { uppercase } from 'scy/text/styles.mod.scss';
import Icon from './Icon';

export default function Summary({ shippingOption = {} }) {
  return (
    <>
      <Icon />
      <AccentH5 tag="h2" className={uppercase}>
        {shippingOption.name}
      </AccentH5>
    </>
  );
}
